
import { Component, Vue, Prop } from 'vue-property-decorator';
import CustomButton from '~/components/Buttons/CustomButton.vue';
import TextInput from '~/components/Inputs/Text.vue';
import { Filter } from '@/interfaces/filter';

@Component({ components: { CustomButton, TextInput } })
export default class MultiselectFilter extends Vue {
  @Prop({ type: Array, required: true }) readonly items!: Filter[];

  selected: string[] = [];

  selectedItem = '';

  search = '';

  get filteredItems() {
    const needle = this.search.toLowerCase();
    return this.items.filter(item => item.label.toLowerCase().includes(needle));
  }

  get allSelected() {
    return this.selected.length === this.items.length;
  }

  isSelected(item: string) {
    return this.selected.indexOf(item) !== -1;
  }

  updateAndFilter(item: string, value: boolean) {
    if (value) this.selected.push(item);
    else this.selected.splice(this.selected.indexOf(item), 1);

    this.$emit('update:items', this.selected);
  }

  clearSelection() {
    this.selected = [];
    this.$emit('update:items', []);
  }

  selectAll() {
    this.selected = this.allSelected ? [] : this.items.map(item => item.label);

    this.$emit('update:items', this.selected);
  }
}
